module.exports = __webpack_public_path__ + "images/sign-up-teaser.png";